var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browse-datepicker"},[_c('NebulaDatepicker',{staticClass:"browse-datepicker__datepicker",class:{ 'browse-datepicker__datepicker--hairline': _vm.hairline },attrs:{"inline":true,"value":_vm.selected},on:{"input":_vm.handleSelection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }